import Image from "next/legacy/image";
import Link from "next/link";
import routes from "@/lib/routes";
import styles from "@/styles/Title.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TitleDetailModal(_ref) {
  let {
    title
  } = _ref;
  const channel = title === null || title === void 0 ? void 0 : title.channel;
  return /*#__PURE__*/_jsx("div", {
    className: styles.detail,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsx("h1", {
        className: styles.title,
        children: title.name
      }), /*#__PURE__*/_jsx("p", {
        className: styles.header,
        children: title.header
      }), /*#__PURE__*/_jsx("p", {
        children: title.description
      }), (title === null || title === void 0 ? void 0 : title.genres) && /*#__PURE__*/_jsx("div", {
        children: title.genres.map(genre => genre.name).join("/")
      }), (title === null || title === void 0 ? void 0 : title.cast) && /*#__PURE__*/_jsx("div", {
        children: title.cast
      }), (title === null || title === void 0 ? void 0 : title.staff) && /*#__PURE__*/_jsx("div", {
        children: title.staff
      }), (title === null || title === void 0 ? void 0 : title.distributor) && /*#__PURE__*/_jsx("div", {
        children: title.distributor
      }), (title === null || title === void 0 ? void 0 : title.copyright) && /*#__PURE__*/_jsx("div", {
        children: title.copyright
      })]
    })
  });
}